(function(){
    'use strict'

    angular
    .module('app.centrosCosto')
    .controller('CentrosCosto', CentrosCosto);

    CentrosCosto.$inject = ['$animationsSrv', 'CentrosCostoService', 'logger', '$location', 'UserInfoService'];

    function CentrosCosto($animationsSrv, CentrosCostoService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.centrosCosto = [];
        vm.title = 'Centros Costo';

        vm.goToEdit = function(centroCosto){
            
            var path = '/editar-centro-costo/';

            if(centroCosto){
                $location.path(path + centroCosto.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = CentrosCostoService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(centrosCosto){
                vm.centrosCosto = centrosCosto;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los centros de Costo.');
                        break;
                }
            });
        };

        vm.delete = function(centroCosto){
            var promise = CentrosCostoService.remove(centroCosto);
            
            promise
            .then(function(response){
                vm.centrosCosto = vm.centrosCosto.filter(function(g) {
                    return g.id !== centroCosto.id;
                });
                logger.success('Centro de Costo eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Centro de Costo');
                        break;
                }
                
            });   
        };

    }
})();